import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class FiscalPeriod  {
    _originalTypeClassName = "zERP.BO.FiscalPeriod";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
FiscalPeriod.translate = translateService;
}
this.Ledgers = [];
this.AccountingPeriods = [];
this.Entity = new Domain.AccountingBusinessEntity();
this.FiscalPeriodID = null;
this.Name = null;
this.StartDate = null;
this.EndDate = null;
this.Closed = false;
this.ClosedOn = null;
this.OpenedOn = null;
this.FinalizedUntil = null;
this._key = this.FiscalPeriodID = 0; 
}

static translate: TranslateService;
_key: any;
private _FiscalPeriodID:any;
get FiscalPeriodID(): any {
    return this._FiscalPeriodID;
  }
set FiscalPeriodID(value: any) {
    this._FiscalPeriodID = value;
    this._key = value;
  }
Name:any;
StartDate:any;
EndDate:any;
Closed:any;
ClosedOn:any;
OpenedOn:any;
FinalizedUntil:any;
Ledgers:any;
AccountingPeriods:any;
DESTINATIONFiscalPeriod:any;
Entity:any;
static setLedgers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Ledgers == null) $this.Ledgers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Ledgers.length > 0) {
                    Domain.FiscalPeriod.removeLedgers($this, $this.Ledgers[0]);
                }

                Domain.FiscalPeriod.addManyLedgers($this, copyItems);
            }
static addManyLedgers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.FiscalPeriod.addLedgers($this, items[i]);
                }
            }
static addLedgers = ($this, item) => {
                if ($this.Ledgers == null) $this.Ledgers = [];
                if (item == null || $this.Ledgers.indexOf(item) > -1) return;
                $this.Ledgers.push(item);
if (item.FiscalPeriod != $this) {
Domain.Ledger.setFiscalPeriod(item, $this);
}
}
static addRangeLedgers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.FiscalPeriod.addLedgers($this, item));
            }
static removeLedgers = ($this, item) => {
                if ($this == null || $this.Ledgers == null || $this.Ledgers.indexOf(item) === -1) return;
                var _index = $this.Ledgers.indexOf(item);
                $this.Ledgers.splice(_index, 1);
item.FiscalPeriod = null;
}
static clearLedgers = ($this) => { $this.Ledgers = null; }
static setAccountingPeriods = ($this, items) => {
                if (items == null) items = [];
                if ($this.AccountingPeriods == null) $this.AccountingPeriods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AccountingPeriods.length > 0) {
                    Domain.FiscalPeriod.removeAccountingPeriods($this, $this.AccountingPeriods[0]);
                }

                Domain.FiscalPeriod.addManyAccountingPeriods($this, copyItems);
            }
static addManyAccountingPeriods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.FiscalPeriod.addAccountingPeriods($this, items[i]);
                }
            }
static addAccountingPeriods = ($this, item) => {
                if ($this.AccountingPeriods == null) $this.AccountingPeriods = [];
                if (item == null || $this.AccountingPeriods.indexOf(item) > -1) return;
                $this.AccountingPeriods.push(item);
if (item.FiscalPeriod != $this) {
Domain.AccountingPeriod.setFiscalPeriod(item, $this);
}
}
static addRangeAccountingPeriods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.FiscalPeriod.addAccountingPeriods($this, item));
            }
static removeAccountingPeriods = ($this, item) => {
                if ($this == null || $this.AccountingPeriods == null || $this.AccountingPeriods.indexOf(item) === -1) return;
                var _index = $this.AccountingPeriods.indexOf(item);
                $this.AccountingPeriods.splice(_index, 1);
item.FiscalPeriod = null;
}
static clearAccountingPeriods = ($this) => { $this.AccountingPeriods = null; }
static setDESTINATIONFiscalPeriod = ($this, value) => {
var oldValue = $this.DESTINATIONFiscalPeriod;
$this.DESTINATIONFiscalPeriod = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}

static CanAddEntryOfType($this: any, generalJournal: any,dryRun: any): any{let validResult = [];
let errorsAndWarnings = [];
return errorsAndWarnings;
}
static CanPerformTransaction($this: any, date: any): any{if ($this?.FinalizedUntil != null && (new Date($this?.FinalizedUntil).getTime()) >= (new Date(date).getTime())) {return false;}
return true;
}
static EnsureCanPerformTransaction($this: any, date: any): any{if (!(Domain.FiscalPeriod.CanPerformTransaction($this, date))) {throw Error("Η εργασία δεν μπορεί να ολοκληρωθεί, διότι η περίοδος είναι κληδωμένη μεχρι τις: " + CLMS.Framework.DateTime.ToString($this?.FinalizedUntil, "dd-MM-yyyy"));}
}
static GetAccountingPeriod($this: any, date: any): any{for (let _iaPeriod = 0; _iaPeriod < ($this?.AccountingPeriods == null ? 0 : $this?.AccountingPeriods.length); _iaPeriod++) {let aPeriod = $this?.AccountingPeriods[_iaPeriod];if ((new Date(new Date(new Date(date)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(new Date(new Date(aPeriod?.StartDate)?.setHours(0, 0, 0, 0))).getTime()) && (new Date(new Date(new Date(aPeriod?.EndDate)?.setHours(0, 0, 0, 0))).getTime()) >= (new Date(new Date(new Date(date)?.setHours(0, 0, 0, 0))).getTime())) {return aPeriod;}}
return null;
}
static UpdateFinalizedUntil($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.Ledgers.length, () => 0)) {$this.FinalizedUntil = null;return;}
let date = Domain.DateHelper.SelectIfNotEmpty($this?.Ledgers?.linq?.orderBy((o) => o?.DateLastUpdated)?.toArray()?.linq?.where()?.firstOrDefault(null)?.DateLastUpdated, $this?.StartDate);
console.warn("finalized unti date: " + date);
$this.FinalizedUntil = ((new Date(date).getTime()) >= (new Date($this?.StartDate).getTime()) ? date : null);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.FiscalPeriodID == null || $this.FiscalPeriodID == 0;
            }


}